export default {
  API_BASE_URL: 'https://proof-app-api-v1-staging.herokuapp.com',
  ALGOLIA_ACCOUNT_INDEX: 'staging_accounts'
}



// WEBPACK FOOTER //
// ./src/api/config.js